import FirstSection from './FirstSection';

export default FirstSection;
